import { render, staticRenderFns } from "./TelesaludView.vue?vue&type=template&id=aa81b0e0"
import script from "./TelesaludView.vue?vue&type=script&lang=ts"
export * from "./TelesaludView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports